import NovoNcm from "../../../components/Cadastros/Novo/NovoNcm";
import Header from "../../../components/Menu";

const NovoNcmPage = () => {
  return (
    <div className="flex">
      <Header />
      <NovoNcm />
    </div>
  );
};

export default NovoNcmPage;
